import {Link} from 'react-router-dom';
import {SquareMousePointer, Compass, CircleQuestionMark, User} from 'lucide-react';

export interface CARD_DATA {
    id: string;
    title: string;
    pageUrl: string;
    icon: React.ComponentType<{ className?: string }>;
}

const TRY_THESE_PAGES: CARD_DATA[] = [
    {
        id: '0',
        title: "Browse icons",
        pageUrl: "/",
        icon: SquareMousePointer,
    },
    {
        id: '1',
        title: "Help center",
        pageUrl: "/faq",
        icon: CircleQuestionMark,
    },
    {
        id: '2',
        title: "My account",
        pageUrl: "/account",
        icon: User,
    },
];

 // I am more lost than found

export const NotFound404 = (any) => {
    return (
        <div className="flex flex-col">
            <main className="flex-grow">
                <section className="py-24 sm:py-32">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="relative flex flex-col items-center">
                            <p className="text-[10rem] sm:text-[12rem] md:text-[16rem] 
                                           font-extrabold text-surface-700 leading-none"
                               aria-hidden="true">
                                404
                            </p>

                            <div className="flex flex-col items-center -mt-20 sm:-mt-24 md:-mt-32">
                                
                                <Compass size={64} className="text-brand-500" />
                                
                                <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-surface-50">
                                    Page Not Found
                                </h1>
                                <p className="mt-4 max-w-xl text-lg text-surface-300">
                                    It seems the page you're looking for has been moved, deleted,
                                    or doesn't exist. Let's get you back on track.
                                </p>
                                <a href="/"
                                   className="mt-8 inline-block bg-brand-500 text-black font-semibold px-8 py-3 rounded-lg hover:bg-opacity-90 transition-all shadow-lg shadow-brand-500/20 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-[var(--bg-primary)]">
                                    Return to Homepage
                                </a>
                            </div>
                        </div>

                        <div className="mt-16 sm:mt-24">
                            <h2 className="text-sm font-semibold text-surface-300 tracking-wider uppercase">
                                Or, try one of these pages:
                            </h2>
                            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
                                {TRY_THESE_PAGES.map(pack => <NavigateToCard  data={pack}/>)}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export const NavigateToCard = ({data}) => {
    const {title, pageUrl, icon : IconComponent} = data as CARD_DATA;
    
    return (
        <Link 
            to={pageUrl}
           className="group flex flex-col items-center justify-center gap-3 rounded-xl border p-6 text-center 
           transition-all duration-200 bg-surface-900 border-surface-800 hover:-translate-y-1 
           hover:border-brand-600 hover:shadow-xl hover:shadow-black/20">

            <IconComponent
                className="h-8 w-8 text-surface-300 group-hover:text-brand-500 transition-colors"
            />
            
            <span
                className="font-semibold text-sm text-surface-50">
                {title}
            </span>
        </Link>
    );
}





















